import pageStyles from "../../../styles/page.module.css";
import Header from "../../header/Header";
import PageNavigation from "../../navigation/PageNavigation";
import ToastWrapper from "../../toaster/ToastWrapper";

export default function PageWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <article className={pageStyles.pageWrapper}>
      <Header />
      <main className={pageStyles.pageBody}>
        <PageNavigation />
        {children}
      </main>
      <ToastWrapper></ToastWrapper>
    </article>
  );
}
